import React from 'react';
import { Paper, Grid, Typography, Box } from '@material-ui/core';
import useStyles from './sampleDevelopmentNl.style';
import { TextFieldFastField } from '../../../components';

interface SampleDevelopmentNlFilePathProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlFilePath: React.FC<SampleDevelopmentNlFilePathProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();

  return (
    <Paper variant="outlined">
      <Box m={1}>
        <Grid container spacing={1} direction="row" justifyContent="flex-start">
          <Grid sm={12} item>
            <Typography className={classes.title}>File Path</Typography>
          </Grid>
          <Grid sm={12} item>
            <TextFieldFastField
              disabled={isCrtLocked}
              name="filePath"
              label="File Path"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default SampleDevelopmentNlFilePath;
